//External libraries
import styled from '@emotion/styled';

export const LanguageDropdownContainer = styled.div`
  @media (max-width: 375px) {
    border-bottom: 1px solid #cbd2d6;
    margin: 0 -18px;
    padding: 0 18px 10px;
  }
`;
